import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { MAFUser, UserState } from '@/store/User/types';
import { FriendState, message, UserWithMessage } from '@/store/Friends/types';
import {ViolationState} from '@/store/Violations/types';
import { Lookup, LookupIcon, LookupDistance } from '../types';
import * as _ from 'lodash';
import { User } from 'firebase';

import Vue from 'vue';

export const getters: GetterTree<ViolationState, RootState> = {
    getResolutions(state): string[] | number[] | LookupIcon[] | LookupDistance[] | undefined {
        return state.resolutions ? state.resolutions.value : undefined;
    },
};
